import { useTranslation } from "react-i18next";
import { StatCard } from "../../components/data/StatCard";

const KPI = [["inventory", "orders", "sky"], ["consumable", "docs", "amber"],
             ["expense", "money", "emerald"], ["asset", "alert", "violet"],
             ["cost_centers", "due", "teal"]];

// بطاقات إحصاء المواد حسب النوع + مراكز التكلفة.
export const ItemStats = ({ stats }) => {
  const { t } = useTranslation();
  if (!stats) return null;

  return (
    <div className="grid gap-3 sm:grid-cols-3 lg:grid-cols-5" data-testid="item-stats">
      {KPI.map(([key, icon, tone]) => (
        <StatCard key={key} testid={`item-stat-${key}`} icon={icon} tone={tone}
                  label={t(`purchases.items.stats.${key}`)} value={stats[key] ?? 0} />
      ))}
    </div>
  );
};
